<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("Order") }}
      </p>
    </div>
    <div class="modal-card-body">
      <div class="container">
        <p>
          {{
            $t(
              "I hereby order the digitization of all pages belonging to the above document as PDF"
            )
          }}
        </p>

        <form class="contact-form" @submit.prevent="sendEmail">
          <b-field :label="$t('Document')">
            <b-input
              v-model="doc"
              :value="doc"
              type="text"
              name="docpath"
              disabled
            />
          </b-field>
          <b-field :label="$t('Document Title')">
            <b-input
              v-model="documentTitle"
              :value="documentTitle"
              type="text"
              name="doctitle"
              disabled
            />
          </b-field>
          <b-field :label="$t('First Name')">
            <b-input
              v-model="firstName"
              type="text"
              name="firstName"
              required
            />
          </b-field>
          <b-field :label="$t('Name')">
            <b-input v-model="name" type="text" name="name" required />
          </b-field>
          <b-field :label="$t('Street')">
            <b-input v-model="street" type="" name="street" required />
          </b-field>
          <b-field :label="$t('House Number')">
            <b-input
              v-model="houseNumber"
              type="number"
              name="houseNumber"
              required
            />
          </b-field>
          <b-field :label="$t('Place')">
            <b-input v-model="place" type="" name="place" required />
          </b-field>
          <b-field :label="$t('Postal Code')">
            <b-input
              v-model="postalCode"
              type="number"
              name="postalCode"
              required
            />
          </b-field>
          <b-field :label="$t('Country')">
            <b-input v-model="country" type="" name="country" required />
          </b-field>
          <b-field :label="$t('Email')">
            <b-input v-model="mail" type="email" name="mail" required />
          </b-field>
          <b-field :label="$t('Comment')">
            <b-input type="textarea" name="message"></b-input>
          </b-field>
          <b-button
            expanded
            icon-right="paper-plane"
            type="is-success"
            native-type="submit"
          >
            {{ $t("Send") }}
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const sgMail = require("@sendgrid/mail");
sgMail.setApiKey(
  "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"
);

export default {
  data() {
    return {
      name: "",
      email: "",
      message: "",
      document: null,
      docpath: null,
      doctitle: null,
      firstName: "",
      name: "",
      street: "",
      houseNumber: "",
      place: "",
      postalCode: "",
      country: "",
      mail: "",
    };
  },
  computed: {
    doc() {
      return (
        "https://transkribus.eu/r/grundbuchblaetter/#" +
        this.$router.history.current.fullPath
      );
    },
    documentTitle() {
      if (this.document) {
        return this.document.title;
      }
      return "test";
    },
    documentId() {
      return this.$route.params["documentId"] || null;
    },
  },
  async mounted() {
    try {
      await this.load();
    } catch (err) {
      console.error(err);
    }
    // await this.api.sendMail(
    //   "f.krull@readcoop.eu",
    //   "info@readcoop.eu",
    //   "Cors Test",
    //   "we are testing cors"
    // );
  },
  methods: {
    async load() {
      this.document = await this.api.fetchDocument(this.documentId);
    },
    sendEmail(e) {
      const subject = `Grundbuchblaetter Bestellung von ${this.firstName} ${this.name}`;
      const body = `Hallo,

    Eine neue Bestellung von ${this.firstName} ${this.name} ist für folgendes Dokument eingelangt:

    ${this.doc} - ${this.documentTitle}

        Email : ${this.mail}
        Vor- und Familienname: ${this.firstName} ${this.name}
        Straße: ${this.street}
        Hausnummer: ${this.houseNumber}
        Ort: ${this.place}
        Postleitzahl:  ${this.postalCode}
        Land : ${this.country}
        ${this.doc}
        ${this.documentTitle}

    Anmerkung:

    ${this.message}

    Schöne Grüße

    Das Transkribus-Team


    Technische Rückfragen bitte an info@readcoop.eu`;

      const mailtoLink = `mailto:landesarchiv@tirol.gv.at,tla-scannen@transkribus.eu?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;

      window.location.href = mailtoLink;
    },
  },
};
</script>
